import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  reservationPart5WeekColumn,
  reservationPart5WeekColumnLessOpacity,
  reservationPart5WeekDate,
  reservationPart5WeekDateJour,
  reservationPart5WeekDateJourNombre,
  reservationPart5WeekDateMois,
  reservationPart5CreneauxDispos,
  reservationPart5CreneauxSubContainer,
  reservationPart5CreneauxCollapsed,
} from "./reservation-part-5.module.scss"
import {
  ReservationPart5WeekDate,
  ReservationPart5WeekDateJourNombre,
  ReservationPart5CreneauxDispos,
  ReservationPart5CreneauxDisposChoisi,
} from "../reservation-styled.js"
import Icon from "../../Icon/icon"

export const ReservationPart5DayColumn = ({
  jour,
  creneauxDisponibles,
  changeWeekOffset,
  changeCreneau,
  creneauChoisi,
}) => {
  const [collapsed, setCollapsed] = useState(true)
  const [width, setWidth] = useState(window.innerWidth)
  const date = new Date(jour + "T00:00")
  const options = {
    weekday: "long",
    day: "numeric",
    month: "long",
  }
  const labelJour = Intl.DateTimeFormat("fr-FR", options).format(date)

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])
  return (
    <div
      className={
        creneauxDisponibles.creneaux.length > 0
          ? reservationPart5WeekColumn
          : reservationPart5WeekColumnLessOpacity
      }
    >
      <ReservationPart5WeekDate
        onClick={() => setCollapsed(!collapsed)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            setCollapsed(!collapsed)
          }
        }}
        tabIndex={
          creneauxDisponibles.creneaux.length > 0 && width < 900 ? 0 : -1
        }
        className={reservationPart5WeekDate}
        role={
          creneauxDisponibles.creneaux.length && width < 900 ? "button" : null
        }
        aria-expanded={width < 900 ? !collapsed : null}
        aria-label={width < 900 ? labelJour : null}
      >
        <p className={reservationPart5WeekDateJour}>
          {creneauxDisponibles.jourLabel}
        </p>
        <ReservationPart5WeekDateJourNombre
          className={reservationPart5WeekDateJourNombre}
        >
          {creneauxDisponibles.jourNombre}
        </ReservationPart5WeekDateJourNombre>
        <p className={reservationPart5WeekDateMois}>
          {creneauxDisponibles.moisLabel}
        </p>
        <p>
          {collapsed ? (
            <Icon size={45} icon="chevron-thin-down"></Icon>
          ) : (
            <Icon size={45} icon="chevron-thin-up"></Icon>
          )}
        </p>
      </ReservationPart5WeekDate>
      <div
        htmlFor={jour}
        className={`${reservationPart5CreneauxSubContainer} ${
          collapsed ? reservationPart5CreneauxCollapsed : ""
        }`}
      >
        {creneauxDisponibles.creneaux.map((heureEtDuree, indexHeure) => {
          const heure = heureEtDuree.split("-")[0]
          const duree = heureEtDuree.split("-")[1]
          const dateCreneau = new Date(jour + "T" + heure)
          const dateFinCreneau = new Date(dateCreneau)
          dateFinCreneau.setHours(dateFinCreneau.getHours() + parseInt(duree))
          const heureFin =
            String(dateFinCreneau.getHours()).padStart(2, "0") +
            ":" +
            String(dateFinCreneau.getMinutes()).padStart(2, "0")
          const dateOptions = {
            weekday: "long",
            day: "numeric",
            month: "long",
            hour: "2-digit",
            minute: "2-digit",
          }

          // Formatter avec Intl.DateTimeFormat
          let labelCreneau = new Intl.DateTimeFormat("fr-FR", dateOptions)

          labelCreneau = labelCreneau.format(dateCreneau)
          if (creneauChoisi.includes(jour + " " + heure + " - " + heureFin)) {
            return (
              <ReservationPart5CreneauxDisposChoisi
                key={heure}
                className={reservationPart5CreneauxDispos}
                onClick={() =>
                  changeCreneau(jour + " " + heure + " - " + heureFin)
                }
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    changeCreneau(jour + " " + heure + " - " + heureFin)
                  }
                }}
                tabIndex={0}
                aria-label={labelCreneau + " - Créneau séléctionné"}
              >
                {heure} - {heureFin}
              </ReservationPart5CreneauxDisposChoisi>
            )
          }
          return (
            <ReservationPart5CreneauxDispos
              key={heure}
              className={reservationPart5CreneauxDispos}
              onClick={() =>
                changeCreneau(jour + " " + heure + " - " + heureFin)
              }
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  changeCreneau(jour + " " + heure + " - " + heureFin)
                }
              }}
              tabIndex={0}
              role={"button"}
              aria-label={labelCreneau}
            >
              {heure} - {heureFin}
            </ReservationPart5CreneauxDispos>
          )
        })}
      </div>
    </div>
  )
}

ReservationPart5DayColumn.propTypes = {
  jour: PropTypes.string,
  creneauxDisponibles: PropTypes.object,
  changeWeekOffset: PropTypes.func,
  changeCreneau: PropTypes.func,
  creneauChoisi: PropTypes.string,
  step: PropTypes.number,
}
